import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getPrefixRoute } from '../../lib/utils/routeUtils';
import { getFirstAllowedRoute } from '../../lib/utils/menu';

const HomeRedirect = () => {
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className='flex items-center justify-center h-screen bg-gradient-to-br from-blue-100 to-indigo-100'>
        <div className='text-center'>
          <div className='w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto'></div>
          <p className='mt-4 text-gray-600 font-medium'>
            Loading your workspace...
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to='/login' replace />;
  }

  const prefixRoute = getPrefixRoute(user);
  if (prefixRoute) {
    return <Navigate to={prefixRoute} replace />;
  }

  // Fallback if no permissions match (or return default unauthorized view)
  return <Navigate to={getFirstAllowedRoute(user.permissions)} replace />;
};

export default HomeRedirect;
